import fetch from '../../../utils/fetch';
import {
    CONTACT_SHOW_ERROR,
    CONTACT_SHOW_LOADING,
    CONTACT_SHOW_RESET,
    CONTACT_SHOW_ANSWERS_VIEW,
    CONTACT_SHOW_ANSWERS_SUCCESS,
    CONTACT_SHOW_INFO_SUCCESS,
    CONTACT_SHOW_STATS_SUCCESS,
} from './mutation-types';
import {CONTACT} from '../../../constants/api-routes';

const  getDefaultState = () => {
    return {
        items: [],
        view: [],
        info: [],
        stats: {
            isFantasyAvg: '',
            isActionAvg: '',
            gaugeLevelAvg: '',
            answerWeightAvg: '',
            total: 0
        },
        totalItems: 0,
    };
};
const state = getDefaultState();

function successAnswers(items, totalItems) {
    return {type: CONTACT_SHOW_ANSWERS_SUCCESS, items, totalItems};
}

function successInfo(info) {
    return {type: CONTACT_SHOW_INFO_SUCCESS, info};
}

function statsSuccess(stats) {
    return {type: CONTACT_SHOW_STATS_SUCCESS, stats};
}

function view(items) {
    return {type: CONTACT_SHOW_ANSWERS_VIEW, items};
}

const getters = {
    items: state => state.items,
    view: state => state.view,
    contactAlias: state => state.info.alias,
    contactId: state => state.info.id,
    contactAliasId: state => state.info.aliasId,
    stats: state => state.stats,
    totalItems: state => state.totalItems,
};

const actions = {
    getContactInfo({commit}, id) {
        fetch(CONTACT + id)
            .then(data => {
                commit(successInfo(data));
            });
    },
    getItems({commit}, url) {
        if (typeof (url) === 'string') {
            url = {listUrl: url}
        }
        let calls = [];
        calls.push(fetch(url.listUrl)
            .then(data => {
                commit(successAnswers(data['hydra:member'], data['hydra:totalItems']));
                commit(view(data['hydra:view']));
            })
            .catch(e => {
                commit(error(e.message));
            }));
        if (url.statsUrl) {
            calls.push(fetch(url.statsUrl)
                .then(data => {
                    commit(statsSuccess(data));
                })
                .catch(e => {
                    commit(error(e.message));
                }));
        }
    },
};

const mutations = {
    [CONTACT_SHOW_ANSWERS_VIEW](state, payload) {
        state.view = payload.items;
    },
    [CONTACT_SHOW_ANSWERS_SUCCESS](state, payload) {
        state.items = payload.items;
        state.totalItems = payload.totalItems;
    },
    [CONTACT_SHOW_RESET](state) {
        Object.assign(state, getDefaultState());
    },
    [CONTACT_SHOW_STATS_SUCCESS](state, {stats}) {
        state.stats = stats;
    },
    [CONTACT_SHOW_INFO_SUCCESS](state, payload) {
        state.info = payload.info;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/show.js